export default __webpack_public_path__ + "static/media/arrowupdown.cfbf4c38.svg";